















import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'BaseErrorSoundButton'
})
export default class BaseErrorSoundButton extends Vue {
  playSound(this: any) {
    const audio: HTMLAudioElement = this.$refs.audio;

    audio.pause();
    audio.currentTime = 0;
    audio.play();
  }
}
